const IMG_URL_PREFIX = '//abres.octlib.com/commonImg/officialStore/';
const IMG_URL_PREFIX_DAMAI =
  '//cdnimages.awselbcombine.com/public_images/product_ext/';
export default {
  computed: {
    gameCode() {
      return this.$store.getters.gameInfoConfig.gameCode;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    imgPrefix() {
      // 日本江美暂不支持后台上传商品图片
      return this.gameId == 2
        ? IMG_URL_PREFIX + this.gameCode + '/'
        : IMG_URL_PREFIX_DAMAI + this.gameId + '/';
    },
    productPropDefaultIcoName() {
      return this.$store.getters.gameInfoConfig.productPropDefaultIcoName;
    },
    productPropDefaultIco() {
      return `${this.imgPrefix}${this.productPropDefaultIcoName}`;
    }
  },
  methods: {
    getGamePropIco(icoName) {
      if (!icoName) {
        return this.productPropDefaultIco;
      }
      return `${this.imgPrefix}${icoName}${
        /\.(png|jpe?g)$/.test(icoName) ? '' : '.png'
      }`;
    },
    handleImgError(e) {
      e.target.src = this.productPropDefaultIco;
    },
    loadImg(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve(url);
        };
        img.onerror = () => {
          reject();
        };
        img.src = url;
      });
    },
    // 江美特殊处理，它的商品名称是个图片，研发返回的图片名字大小写不一致，优先加载全小写的图片，加载失败再按原图片名字加载。
    getBeautyNameIco(nameIco, boolLowerCase = true) {
      if (!nameIco) {
        return;
      }
      return `${IMG_URL_PREFIX}beauty/name/${
        boolLowerCase ? nameIco.toLocaleLowerCase() : nameIco
      }`;
    },
    getBeautyProductIco(productIcon, boolLowerCase = true) {
      if (!productIcon) {
        return;
      }
      return `${IMG_URL_PREFIX}beauty/${
        boolLowerCase ? productIcon.toLocaleLowerCase() : productIcon
      }`;
    },
    beautyNameIcoError(e, nameIco) {
      // 先预加载图片，成功加载了才赋值，否则会无限循环触发error事件
      this.loadImg(this.getBeautyNameIco(nameIco, false)).then(src => {
        e.target.src = src;
      });
    },
    beautyProductIcoError(e, productIcon) {
      this.loadImg(this.getBeautyProductIco(productIcon, false)).then(src => {
        e.target.src = src;
      });
    }
  }
};
